import React, { useCallback, useState } from 'react';

import {
  type DrawerMenuItem,
  type MobileHeaderPageStackItem } from
'~/interfaces/HeaderFooterNavV2';

import WrappedIcon from '../../../WrappedIcon';
import SubComponent from '../SubComponent';

import styles from './link-with-page.module.css';

interface LinksPage {
  callback?: (text: string) => void;
  hideIcons?: boolean;
  label: string;
  page: DrawerMenuItem;
  pageClick: (item: MobileHeaderPageStackItem) => void;
}

const LinksPage = ({
  callback,
  hideIcons,
  label,
  page: { groups = [], icon, items = [], name, subLinks = [], type },
  pageClick
}: LinksPage): JSX.Element | null => {
  const [showLinksPage, setShowLinksPage] = useState(false);

  const handlePageClick = useCallback(() => {
    setShowLinksPage((showLinks) => !showLinks);
    pageClick({ label: name, clickEvent: () => setShowLinksPage(false) });
  }, [name, pageClick]);

  if (!name) {
    return null;
  }

  return (
    <div>
			<div
        className={styles.link}
        data-testid="page-links"
        key={name}
        onClick={handlePageClick}
        role="button"
        tabIndex={0}>

				<WrappedIcon
          containerClassName={styles.iconContainer}
          hideIcon={hideIcons}
          iconClassName={styles.linkIcon}
          iconString={icon || ''} />

				<div className={styles.linkText}>{name}</div>
				<div className={styles.arrow}></div>
			</div>
			<SubComponent
        callback={callback}
        groups={groups}
        items={items}
        label={label}
        name={name}
        pageClick={pageClick}
        showLinksPage={showLinksPage}
        subLinks={subLinks}
        type={type} />

		</div>);

};

export default LinksPage;